function t(e,o){t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function t(e,o){e.__proto__=o;return e};return t(e,o)}export{t as default};
//# sourceMappingURL=setPrototypeOf.js.map
